<template>
    <v-flex xs12 class="selected-criteria-inline">
    	<v-sheet color="grey lighten-3" class="selected-criteria-wrapper mb-3">
    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.genders.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1">เพศ : </strong>
      			{{ options.genders.filter(o => criteria.genders.includes(o.value)).map(g => g.label).join(', ') }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.ages.length && criteria.ages[0] > 0 && criteria.ages[1] > 0">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1">อายุ : </strong>
      			{{ `${criteria.ages[0]} ถึง ${criteria.ages[1]}` }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.skinTones.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1">โทนผิวหน้า : </strong>
      			{{ criteria.skinTones.join(', ') }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.skinConditions.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1">สภาพผิวหน้า : </strong>
      			{{ criteria.skinConditions.join(', ') }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.hairColors.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1">สีผม : </strong>
      			{{ criteria.hairColors.join(', ') }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.hairConditions.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1">สภาพผม : </strong>
      			{{ criteria.hairConditions.join(', ') }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.skinProblems.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1" v-html="`ปัญหาผิวหน้า ${criteria.skinProblemsAll ? '(ต้องมีทั้งหมด) ' : ''}: `"></strong>
      			{{ criteria.skinProblems.join(', ') }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.bodyProblems.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1" v-html="`ปัญหาผิวกาย ${criteria.bodyProblemsAll ? '(ต้องมีทั้งหมด) ' : ''}: `"></strong>
      			{{ criteria.bodyProblems.join(', ') }}
			</v-chip>

    		<v-chip label color="primary" text-color="white" v-if="criteria && criteria.hairProblems.length">
      			<v-icon left>label</v-icon>
      			<strong class="mr-1" v-html="`ปัญหาเส้นผม ${criteria.hairProblemsAll ? '(ต้องมีทั้งหมด) ' : ''}: `"></strong>
      			{{ criteria.hairProblems.join(', ') }}
			</v-chip>
    	</v-sheet>
		<v-navigation-drawer
			v-if="criteria"
			v-model="changingCriteria"
			:width="clientWidth"
			fixed
			right
			temporary
			class="related-content-list-picker pa-3"
			@input="handleDrawerToggled">

			<v-card flat class="mb-5 activity-selection-criteria">
				<v-card-title primary-title>
					<h1 class="headline">Selection Criteria</h1>
				</v-card-title>

				<v-card-text class="criteria-list">
					<table class="v-datatable v-table theme--light">
						<tbody>
							<tr>
								<th width="45%">
									<v-checkbox hide-details v-model="criteria.selects" value="gender" label="เพศ"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('gender')">
									    <v-checkbox v-for="gender in options.genders" hide-details v-model="criteria.genders" :label="gender.label" :value="gender.value"></v-checkbox>
									</template>
									<template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="age" label="อายุ"></v-checkbox>
								</th>
								<td class="age-slider">
									<template v-if="criteria.selects.includes('age')">
										<v-text-field v-model="criteria.ages[0]" class="mt-0" outline hide-details single-line readonly></v-text-field>
										<v-range-slider v-model="criteria.ages" :max="60" :min="13" hide-details></v-range-slider>
										<v-text-field v-model="criteria.ages[1]" class="mt-0" outline hide-details single-line readonly></v-text-field>
									</template>
									<template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="skinTone" label="ลักษณะผิวหน้า : สีผิว"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('skinTone')">
									    <v-checkbox hide-details 
									    	v-for="option in options.skinTone" 
									    	v-model="criteria.skinTones" 
									    	:label="option" 
									    	:value="option">
								    	</v-checkbox>
									</template>
									<template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="skinCondition" label="ลักษณะผิวหน้า : สภาพผิว"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('skinCondition')">
									    <v-checkbox hide-details 
									    	v-for="option in options.skinCondition" 
									    	v-model="criteria.skinConditions" 
									    	:label="option" 
									    	:value="option">
								    	</v-checkbox>
									</template>
									<template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="hairColor" label="ลักษณะเส้นผม : สีผม"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('hairColor')">
									    <v-checkbox hide-details 
									    	v-for="option in options.hairColor" 
									    	v-model="criteria.hairColors" 
									    	:label="option" 
									    	:value="option">
								    	</v-checkbox>
								    </template>
								    <template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="hairCondition" label="ลักษณะเส้นผม : สภาพผม"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('hairCondition')">
									    <v-checkbox hide-details 
									    	v-for="option in options.hairCondition" 
									    	v-model="criteria.hairConditions" 
									    	:label="option" 
									    	:value="option">
								    	</v-checkbox>
								    </template>
								    <template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="skinProblem" label="ปัญหาผิวหน้า"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('skinProblem')">
									    <v-checkbox hide-details 
									    	v-for="option in options.skinProblem" 
									    	v-model="criteria.skinProblems" 
									    	:label="option" 
									    	:value="option">
								    	</v-checkbox>

										<hr class="my-1">

										<v-radio-group hide-details v-model="criteria.skinProblemsAll" column>
											<v-radio label="ต้องมีที่เลือกทั้งหมด" :value="1"></v-radio>
											<v-radio label="มีข้อใดข้อหนึ่ง" :value="0"></v-radio>
										</v-radio-group>
								    </template>
								    <template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="bodyProblem" label="ปัญหาผิวกาย"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('bodyProblem')">
									    <v-checkbox hide-details 
									    	v-for="option in options.bodyProblem" 
									    	v-model="criteria.bodyProblems" 
									    	:label="option" 
									    	:value="option">
								    	</v-checkbox>

										<hr class="my-1">

										<v-radio-group hide-details v-model="criteria.bodyProblemsAll" column>
											<v-radio label="ต้องมีที่เลือกทั้งหมด" :value="1"></v-radio>
											<v-radio label="มีข้อใดข้อหนึ่ง" :value="0"></v-radio>
										</v-radio-group>
								    </template>
								    <template v-else>&nbsp;</template>
								</td>
							</tr>
							<tr>
								<th>
									<v-checkbox hide-details v-model="criteria.selects" value="hairProblem" label="ปัญหาเส้นผม"></v-checkbox>
								</th>
								<td>
									<template v-if="criteria.selects.includes('hairProblem')">
									    <v-checkbox hide-details 
									    	v-for="option in options.hairProblem" 
									    	v-model="criteria.hairProblems" 
									    	:label="option" 
									    	:value="option">
								    	</v-checkbox>

										<hr class="my-1">

										<v-radio-group hide-details v-model="criteria.hairProblemsAll" column>
											<v-radio label="ต้องมีที่เลือกทั้งหมด" :value="1"></v-radio>
											<v-radio label="มีข้อใดข้อหนึ่ง" :value="0"></v-radio>
										</v-radio-group>
								    </template>
								    <template v-else>&nbsp;</template>
								</td>
							</tr>

						</tbody>
					</table>

				</v-card-text>

			</v-card>
			
		</v-navigation-drawer>
		<v-btn class="btn-add-criteria" small dark fab @click="changingCriteria = true">
			<v-icon>edit</v-icon>
        </v-btn>
 	</v-flex>	
</template>

<script>
	import * as config from '@/config'

	export default {
		props: ['value'],
		data () {
			return {
				criteria: {
					selects: [],
					genders: [],
					ages: [0, 0],
					skinTones: [],
					skinConditions: [],
					hairColors: [],
					hairConditions: [],
					skinProblems: [],
					skinProblemsAll: 0,
					bodyProblems: [],
					bodyProblemsAll: 0,
					hairProblems: [],
					hairProblemsAll: 0,
				},
				options: {
					genders: [
						{
							value: 'F',
							label: 'หญิง'
						},
						{
							value: 'M',
							label: 'ชาย'
						},
						{
							value: 'X',
							label: 'อื่นๆ'
						}
					],
					skinTone: [
						"ผิวขาวซีด",
						"ผิวขาว",
						"ผิวสองสี",
						"ผิวคมเข้ม"
					],
					skinCondition: [
						"ผิวมัน",
						"ผิวแห้ง",
						"ผิวผสม",
						"ผิวแพ้ง่าย",
						"ผิวธรรมดา"
					],
					hairColor: [
						"สีตามธรรมชาติ",
						"ทำสีโทนธรรมชาติ",
						"ทำสีสนุกสนาน"
					],
					hairCondition: [
						"ผมตรง",
						"ผมหยักศก",
						"ผมหยิก",
						"ผมหนา",
						"ผมบาง"
					],
					skinProblem: [
						"ผิวแพ้ง่าย",
						"ผิวเป็นสิว",
						"รูขุมขนกว้าง",
						// "จุดด่างดำ รอยแผลเป็น",
						"จุดด่างดำ",
						"สีผิวไม่สม่ำเสมอ",
						// "ผิวหน้าไม่เรียบเนียน",
						"ผิวไม่เรียบเนียน",
						// "ฝ้า - กระ",
						"ฝ้า",
						"กระ",
						"ผิวขาดน้ำ",
						"ผิวหมองคล้ำ",
						"ปัญหาใต้ตา",
						"หลุมสิว",
						"ริ้วรอย",
						"ริ้วรอยรอบดวงตา",
						"ใต้ตาคล้ำ",
						"ผิวแห้งกร้าน",
						"ผิวหย่อนคล้อย"
					],
					bodyProblem: [
						"สิว",
						"ขนคุด",
						"รอยแตกลาย",
						"เซลลูไลท์",
						"รอยแผลเป็น",
						"สีผิวไม่สม่ำเสมอ",
						"ผิวแห้งกร้าน"
					],
					hairProblem: [
						"ผมร่วง",
						"ผมแห้งเสีย แตกปลาย",
						"ผมไม่มีน้ำหนัก ลีบ แบน",
						"ผมขาดง่าย",
						"ผมพังจากการทำเคมี",
						"รังแค ปัญหาหนังศีรษะ"
					],
				},
				changingCriteria: false,
			}
		},
		computed: {
			clientWidth () 
			{
				return (window.innerWidth > 640) ? 640 : window.innerWidth
			}
		},
		methods: {
			handleDrawerToggled (value)
			{
				if (!value) this.$emit('close')
			},
			initComponent ()
			{
				this.criteria = this.value
			}
		},
		mounted () {
			this.$nextTick(this.initComponent)
		},
		watch: {
			criteria: {
				handler (value) {
					if (value && !value.selects.includes('gender') && this.criteria.genders && Array.isArray(this.criteria.genders) && this.criteria.genders.length > 0) {
						this.criteria.genders = []
					}
					if (value && value.selects.includes('age')) {
						if (this.criteria.ages[0] == 0) this.criteria.ages[0] = 18
						if (this.criteria.ages[1] == 0) this.criteria.ages[1] = 35
					} else {
						if (this.criteria.ages[0] != 0) this.criteria.ages[0] = 0
						if (this.criteria.ages[1] != 0) this.criteria.ages[1] = 0
					}
					if (value && !value.selects.includes('skinTone') && this.criteria.skinTones && Array.isArray(this.criteria.skinTones) && this.criteria.skinTones.length > 0) {
						this.criteria.skinTones = []
					}
					if (value && !value.selects.includes('skinCondition') && this.criteria.skinConditions && Array.isArray(this.criteria.skinConditions) && this.criteria.skinConditions.length > 0) {
						this.criteria.skinConditions = []
					}
					if (value && !value.selects.includes('hairColor') && this.criteria.hairColors && Array.isArray(this.criteria.hairColors) && this.criteria.hairColors.length > 0) {
						this.criteria.hairColors = []
					}
					if (value && !value.selects.includes('hairCondition') && this.criteria.hairConditions && Array.isArray(this.criteria.hairConditions) && this.criteria.hairConditions.length > 0) {
						this.criteria.hairConditions = []
					}
					if (value && !value.selects.includes('skinProblem') && this.criteria.skinProblems && Array.isArray(this.criteria.skinProblems) && this.criteria.skinProblems.length > 0) {
						this.criteria.skinProblems = []
					}
					if (value && !value.selects.includes('bodyProblem') && this.criteria.bodyProblems && Array.isArray(this.criteria.bodyProblems) && this.criteria.bodyProblems.length > 0) {
						this.criteria.bodyProblems = []
					}
					if (value && !value.selects.includes('hairProblem') && this.criteria.hairProblems && Array.isArray(this.criteria.hairProblems) && this.criteria.hairProblems.length > 0) {
						this.criteria.hairProblems = []
					}

					this.$emit('input', this.criteria)
				},
				deep: true
			},
			value (props) {
				this.initComponent()
			}
		}
	}
</script>

<style lang="scss">
	.selected-criteria-inline {
		position: relative;

		.btn-add-criteria {
			position: absolute;
			right: .5rem;
			bottom: .5rem;
		}

		.search-result {
			.v-card__text {
				padding: 0;
			}
		}
	}
	.selected-criteria-wrapper {
		display: flex;
		flex-flow: row wrap;
		padding: 15px;

		min-height: 70px;
	}

	.criteria-list table {
		tbody tr {
			th, td {
				padding: 15px !important;
				height: unset !important;
			}
			td:last-child {
				display: grid;
				grid-gap: 15px;

				&.age-slider {
					grid-template-columns: 42px 1fr 42px;
					align-items: center;

					.v-input__slot {
						padding: 0;
					}
					.v-input--range-slider {
						margin-top: 0;
					}

					input {
						font-size: 80%;
						text-align: center;
						padding: 0;
					}
				}

				&:not(.age-slider) {
					grid-template-columns: 1fr;
				}

				hr, .v-input--radio-group--row {
					grid-column: 1/-1;
				}
			}
		}
	}
</style>